<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <menu tabindex="-1">
    <PrimaryItem
      v-for="year in years"
      :key="`navPrim-${year}`"
      class="year item"
      :to="year"
      :selected="year === selected">
      {{ year }}
    </PrimaryItem>
  </menu>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line

// eslint-disable-next-line
const props = defineProps({
  years: {default: []},
  selected: {default: ""}
});
import PrimaryItem from "@/components/Navigation/Primary/Item.vue";
</script>

<style scoped>
.lightMode menu :deep(a) {
  /* dropdown menu but not 'archive' button */
  text-shadow: none !important;
}
menu {
  display: inline-block;
  position: absolute;
  top: 2rem; /* -0.15rem */
  left: 0rem; /* -0.56rem; */
  margin: 0;
  padding: 0;
  min-width: 100%; /* adopts width of parent <button> */
  text-align: right;
  background-color: var(--background-color-subtle);
  border: 1px solid var(--border-color);
  border-radius: 0.4rem;
  box-shadow: 0px 0.13rem 0.13rem var(--box-shadow-color);
}
menu .item {
  line-height: 1.7rem; /* was: 1.4em */
}
/* menu .year :focus, */
menu .year :hover {
  color: var(--primary-navigation-color) !important; /* over-ride selection */
  background-color: var(--brand-color);
  border-radius: 0;
}
menu .year:last-child :hover {
  border-bottom-left-radius: 0.4rem; /* last item only */
  border-bottom-right-radius: 0.4rem; /* last item only */
}
menu .year:first-child :hover {
  border-top-left-radius: 0.4rem; /* last item only */
  border-top-right-radius: 0.4rem; /* last item only */
}
menu .item :deep(a) {
  display: block; /* expand to fill horizontal space of parent <li> */
  padding: 0 0.5rem; /*compensates for right: -0.5rem */
  color: var(--text-color-subtle); /* :deep() overrides default link color */
  /* text-align: right; */
}
</style>
